export enum ComplianceScreenNames {
  COMPLIANCE = 'compliance',
  MAIN = 'complaince-nav',
  COMPLIANCE_FIELD = 'compliance-field',
}
